import React, { useState, useEffect } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";

import {
  subirImagenesBatch,
  addRegistro,
  getEmployeeNumber,
  getUserByEmail,
  loadAccountList,
} from "../utils/Actions";
import { isEmpty } from "lodash";
import Avatar from "@material-ui/core/Avatar";
import { Loading } from "../atoms";
import { sendEmail, validaremail } from "../utils/Utils";
import { ADMINEMAIL } from "../config/emails";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";

const inintialState = {
  titulo: "",
  descripcion: "",
  fecha: new Date(),
  photo: "",
  tiporeclamo: "1",
  status: false,
};

const roles = [
  { code: 1, title: "Pregunta" },
  { code: 2, title: "Reclamos" },
];

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  icon: {
    alignSelf: "center",
  },
  avatar: {
    width: 100,
    height: 100,
    marginBottom: 20,
  },
}));

export default function AddUser() {
  const [state, setstate] = useState(inintialState);
  const [visible, setVisible] = useState(false);
  const [accountlist, setaccountlist] = useState([]);

  let history = useHistory();

  useEffect(() => {
    (async () => {
      console.log("LOAD ACCOUNT LIST");
      setaccountlist((await loadAccountList()).data);
    })();
  }, []);

  const classes = useStyles();

  const account = localStorage.getItem("Account");

  const defaultProps = {
    options: roles,
    getOptionLabel: (option) => option.title,
  };

  const defaultProps2 = {
    options: accountlist,
    getOptionLabel: (option) => option.name,
  };

  const fileSelectedHandler = async (event) => {
    setVisible(true);

    setstate({ ...state, photo: event.target.files });
    setVisible(false);
  };

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const _saveuser = async () => {
    //1. Subir imagen
    const { titulo, descripcion, fecha, photo, tiporeclamo, status } = state;

    if (isEmpty(titulo)) {
      alert("Favor ingrese un título");
    } else if (isEmpty(descripcion)) {
      alert("Favor ingrese una descripción");
    } else {
      setVisible(true);
      //2. Generar claves

      let photoup = "";
      if (photo) {
        const resultado = await subirImagenesBatch(photo, "PhotoReclamos");
        photoup = resultado[0];
      }

      const account = localStorage.getItem("Account");
      const accountJSON = JSON.parse(account);

      const { id, accountAsigned, accountAsignedName, email, name, lastname } =
        accountJSON[0];

      const reclamoopregunta = {
        titulo,
        descripcion,
        fecha,
        photo: photoup,
        tiporeclamo,
        status,
        createdBy: id,
        accountAsigned,
        accountAsignedName,
        email,
        name,
        lastname,
        viewed: 0,
      };
      console.log("Estos son los datos");
      console.log(reclamoopregunta);
      const registro = await addRegistro("Claims", reclamoopregunta);

      const asunto = encodeURIComponent("Nuevo Registro de Pregunta o Reclamo");

      const body = encodeURIComponent(
        `Equipo de Sayeret,  <br><br> El cliente ${name} ${lastname}, de la cuenta ${accountAsignedName}. Ha registrado una nueva pregunta o reclamo. <br>Favor confirmar. <br><br> Para ver los detalles a través de nuestra plataforma presione <a href="https://www.sayeretsecurity.net/">Aquí</a>. <br><br> Sayeret App`
      );
      const destino = encodeURIComponent(ADMINEMAIL);
      await sendEmail(body, asunto, destino); // Descomentar eso cuando ya se defina

      console.log("RESPUESTA");
      console.log(registro);

      if (registro.statusresponse === true) {
        await sendEmail(
          `Se ha creado su solicitud.<br><br> Pronto personal de la empresa estará en contácto con usted. <br><br><br> Para ver los detalles a través de nuestra plataforma presione <a href="https://www.sayeretsecurity.net/">Aquí</a>.<br>`,
          "Nuevo Reclamo o Pregunta",
          email
        );
        alert("Se ha creado el registro éxitosamente");
        history.push("/claims");
      } else {
        setVisible(false);
        alert("Ha ocurrido un error - CODIGO" + registro.error);
      }
    }
    setVisible(false);
  };

  return (
    <FormControl
      style={{
        backgroundColor: "#fff",
        borderRadius: 5,
        padding: 20,
        paddingBottom: 30,
      }}
    >
      <Typography gutterBottom variant="h5">
        <IconButton>
          <ChevronLeftIcon onClick={() => history.goBack()} />
        </IconButton>
        Agregar Preguntas o Reclamos
      </Typography>

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Título"
            variant="outlined"
            fullWidth
            name="titulo"
            onChange={onChange}
            value={state.titulo}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Descripción"
            variant="outlined"
            fullWidth
            name="descripcion"
            onChange={onChange}
            value={state.descripcion}
            multiline={true}
            rows={4}
          />
        </Grid>
        {/*
          <Grid item xs={6}>
            <TextField
              id="outlined-basic"
              label="Resolución"
              variant="outlined"
              fullWidth
              name="userweb"
              onChange={onChange}
              disabled
              value={`${state.name}.${state.lastname}`}
            />
          </Grid> */}
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Fecha"
            variant="outlined"
            fullWidth
            type="date"
            name="fecha"
            onChange={onChange}
            value={state.fecha}
          />
        </Grid>

        <Grid
          item
          xs={6}
          direction="column"
          justify="center"
          alignItems="center"
          container
          spacing={0}
          style={{ marginBottom: 20 }}
        >
          <input
            type="file"
            onChange={fileSelectedHandler}
            accept="image/png, image/jpeg"
          />
        </Grid>

        <Grid item xs={4}>
          <Autocomplete
            {...defaultProps}
            id="open-on-focus"
            openOnFocus
            renderInput={(params) => (
              <TextField {...params} label="Tipo de Registro" margin="normal" />
            )}
            onChange={(event, newValue) => {
              console.log(newValue);
              setstate({ ...state, tiporeclamo: newValue.code });
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          direction="row"
          justify="center"
          alignItems="center"
          container
        >
          <Button
            size="large"
            variant="contained"
            color="secondary"
            startIcon={<SaveIcon />}
            onClick={_saveuser}
          >
            REGISTRAR
          </Button>
        </Grid>
      </Grid>
      <Loading visible={visible} setVisible={setVisible} />
    </FormControl>
  );
}
